function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { AppBarAppMobileTeleporter } from "@sprout/client-components/dist/AppBar";
import { Flex } from "sprout-ui-primitives";
import { UserType } from "sprout-graphql";
import { Menu, MenuTrigger, useMenuState, MenuTitle, MenuItem } from "@sprout/list-navigation/dist/Menu";
import { Button } from "sprout-ui-dom";
import { EditOutlined, MoreHoriz, SettingsOutlined } from "sprout-ui-icons";
import useProfileAuthorization from "./useProfileAuthorization";
const ProfilePageUserAppBarMobile = (props)=>{
    const { user  } = props;
    const { type , username  } = user;
    const menuState = useMenuState();
    const authorization = useProfileAuthorization(user);
    if (!authorization.editProfile && !authorization.viewSettings) return null;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(AppBarAppMobileTeleporter, {
                children: /*#__PURE__*/ _jsx(Flex, {
                    ml: "auto",
                    mr: "-4px",
                    alignItems: "center",
                    children: /*#__PURE__*/ _jsx(MenuTrigger, _objectSpread({}, menuState, {
                        children: /*#__PURE__*/ _jsx(Button, {
                            variant: "circle",
                            children: /*#__PURE__*/ _jsx(MoreHoriz, {})
                        })
                    }))
                })
            }),
            /*#__PURE__*/ _jsxs(Menu, _objectSpread({}, menuState, {
                children: [
                    /*#__PURE__*/ _jsx(MenuTitle, {
                        children: type === UserType.Team ? "Workspace Options" : "Options"
                    }),
                    authorization.editProfile && /*#__PURE__*/ _jsx(MenuItem, {
                        icon: /*#__PURE__*/ _jsx(EditOutlined, {}),
                        label: "Edit",
                        to: `/${type === UserType.Team ? username : "my"}/edit-profile`
                    }),
                    authorization.viewSettings && /*#__PURE__*/ _jsx(MenuItem, {
                        icon: /*#__PURE__*/ _jsx(SettingsOutlined, {}),
                        label: "Settings",
                        to: `/${username}/settings`
                    })
                ]
            }))
        ]
    });
};
export default ProfilePageUserAppBarMobile;
